// extracted by mini-css-extract-plugin
export var dataCell = "_po-2";
export var dataRow = "_po-0";
export var headerRow = "_po-1";